module.exports = __webpack_public_path__ + "img/Subtraction 6.48304c58.png";